// extracted by mini-css-extract-plugin
module.exports = {"FontLabel":"FontLabel_FontLabel__DqQSI","FontLabelInner":"FontLabel_FontLabelInner__t_2Cj","Checked":"FontLabel_Checked__HE9br"};